import { defineMessages } from "react-intl";

import { node as alcohol } from "src/modules/ktx/forms/transplantation-screening/medical-history/risks/alcohol";
import { node as allergiesAndSensitivities } from "src/modules/ktx/forms/transplantation-screening/medical-history/risks/allergiesAndSensitivities";
import { node as smoking } from "src/modules/ktx/forms/transplantation-screening/medical-history/risks/smoking";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.risks",
		defaultMessage: "Kockázati tényezők"
	}
});

export const node: ParentNode = {
	id: "ktx-risks",
	value: { type: "wizard", title: messages.title },
	children: [alcohol, smoking, allergiesAndSensitivities]
};
